export default (to, from, next) => {
  if (sessionStorage.subscription_success) {
    next();
  } else {
    next({ name: 'erro' });
  }
};
